import axiosapi from "./axiosAPI";

// Get All IncidentResponseStatus
export const getAllIncidentResponseStatuses = async (
    setIncidentResponseStatuses,
    setFetcherror,
) => {
    
	try{
		const res =await axiosapi.get("/responsestatuses");
        setIncidentResponseStatuses(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch IncidentResponseStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch IncidentResponseStatus");
		}
		
	}
	
};



// Get One IncidentResponseStatus
export const getOneIncidentResponseStatus = async (
    pkid,
    setFetcherror,  
    setIncidentResponseStatus
    
)=>{
	try{
		const res =await axiosapi.get(`/responsestatuses/${pkid}`);
        setIncidentResponseStatus(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch IncidentResponseStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch IncidentResponseStatus");
		}
		
	}
	
};


// Create New IncidentResponseStatus
export const createIncidentResponseStatus = async (
    incidentResponseStatus,
    setIncidentResponseStatus,
    setFetcherror,
    handleAllToasts,
    setIncidentResponseStatuses

) => {

    if (!incidentResponseStatus ) {
        handleAllToasts(2, "No IncidentResponseStatus Provided"); 
            return; 
        }

    const PushItem = {
            name: incidentResponseStatus,
        };

    try{
        await axiosapi.post("/responsestatuses/",PushItem );
        setIncidentResponseStatus("");
        handleAllToasts(1, "IncidentResponseStatus Created Successfully");
        getAllIncidentResponseStatuses(setIncidentResponseStatuses,setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New IncidentResponseStatus");
            handleAllToasts(2, "Could Not update The IncidentResponseStatus");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New IncidentResponseStatus");
            handleAllToasts(2, "Could Not update The IncidentResponseStatus");
            
        }
        
    }
    
}


// Edit Existing IncidentResponseStatus

export const editIncidentResponseStatus = async (
    incidentResponseStatuspkid,
    incidentResponseStatus,
    setIncidentResponseStatus,
    setFetcherror,
    handleAllToasts,
    setIncidentResponseStatuses
              
        ) => {

            if (!incidentResponseStatus) {
                handleAllToasts(2, "No IncidentResponseStatus Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:incidentResponseStatuspkid,
                    name: incidentResponseStatus,
                };

            try{
                await axiosapi.patch("/responsestatuses/",PushItem );
                setIncidentResponseStatus("");
                handleAllToasts(1, "IncidentResponseStatus Updated Successfully");
                getAllIncidentResponseStatuses(setIncidentResponseStatuses,setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update IncidentResponseStatus");
                    handleAllToasts(2, "Could Not Update IncidentResponseStatus");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update IncidentResponseStatus");
                    handleAllToasts(2, "Could Not Update IncidentResponseStatus");
                    
                }
                
            }
            
};



// Delete Existing IncidentResponseStatus.

export const deleteIncidentResponseStatus = async (
    incidentResponseStatuspkid,
    setIncidentResponseStatuses,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/responsestatuses/${incidentResponseStatuspkid}`);
        let finalData = res.data.message;
        getAllIncidentResponseStatuses(setIncidentResponseStatuses, setFetcherror);
        handleAllToasts(1, "IncidentResponseStatus Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete IncidentResponseStatus");
            handleAllToasts(2,"Error: Could Not Delete IncidentResponseStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete IncidentResponseStatus");
            handleAllToasts(2,"Error: Could Not Delete IncidentResponseStatus");
		}
		
	}
	
};
